import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { addressFormSchema } from '../addess/schema';

export const deleteWorkScheduleSlotRecurrenceModes = [
  'delete-occurrence',
  'stop-recurrence',
] as const;
const deleteWorkScheduleSlotRecurrenceModeSchema = z.enum(
  deleteWorkScheduleSlotRecurrenceModes,
);
export type DeleteWorkScheduleSlotRecurrenceMode = z.infer<
  typeof deleteWorkScheduleSlotRecurrenceModeSchema
>;

export const addOfficeFormSchema = z
  .object({
    mode: deleteWorkScheduleSlotRecurrenceModeSchema,
  })
  .merge(addressFormSchema);

export type DeleteWorkScheduleSlotRecurrenceFormValues = z.infer<
  typeof addOfficeFormSchema
>;

export const deleteWorkScheduleSlotRecurrenceFormResolver =
  zodResolver(addOfficeFormSchema);
